import { ShieldCheck, Mail } from "lucide-react";

export const LegalPage = ({ prefix, title, updated, sections, contactTitle = "Contact Us", contactIntro, closing }) => (
  <div className="bg-[#F4F7FC] min-h-screen" data-testid={`${prefix}-page`}>
    <div className="bg-[#0A192F] text-white">
      <div className="max-w-4xl mx-auto px-5 lg:px-8 py-14">
        <span className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/15 px-3 py-1 text-xs font-bold text-[#4FD1C5]"><ShieldCheck className="w-4 h-4" />Legal</span>
        <h1 className="mt-4 font-['Outfit'] font-black text-4xl sm:text-5xl lg:text-6xl" data-testid={`${prefix}-title`}>{title}</h1>
        <p className="mt-3 text-slate-300" data-testid={`${prefix}-updated`}>Last updated: {updated}</p>
      </div>
    </div>
    <article className="max-w-4xl mx-auto px-5 lg:px-8 py-12">
      <div className="rounded-3xl bg-white border border-slate-200 p-6 sm:p-10 space-y-9 text-slate-700 leading-relaxed">
        {sections.map(([h, paras, list], i) => (
          <section key={h} data-testid={`${prefix}-section-${i + 1}`}>
            <h2 className="font-['Outfit'] font-extrabold text-xl sm:text-2xl text-[#0A192F]">{h}</h2>
            {paras?.map((p) => <p key={p} className="mt-3">{p}</p>)}
            {list && <ul className="mt-3 space-y-2 list-disc pl-5 marker:text-[#FF2E63]">{list.map((l) => <li key={l}>{l}</li>)}</ul>}
          </section>
        ))}
        <section data-testid={`${prefix}-section-${sections.length + 1}`}>
          <h2 className="font-['Outfit'] font-extrabold text-xl sm:text-2xl text-[#0A192F]">{sections.length + 1}. {contactTitle}</h2>
          <p className="mt-3">{contactIntro}</p>
          <div className="mt-4 rounded-2xl bg-[#F4F7FC] border border-slate-200 p-5 space-y-1">
            <p><span className="font-bold text-[#0A192F]">Email:</span> <a href="mailto:luxeray.smarthomes@gmail.com" className="inline-flex items-center gap-1 text-[#007A8A] font-semibold hover:underline" data-testid={`${prefix}-contact-email`}><Mail className="w-4 h-4" />luxeray.smarthomes@gmail.com</a></p>
            <p><span className="font-bold text-[#0A192F]">Company:</span> RoboSpark PrP Pvt Ltd</p>
          </div>
        </section>
        <p className="pt-6 border-t border-slate-200 font-semibold text-[#0A192F]" data-testid={`${prefix}-agreement`}>{closing}</p>
      </div>
    </article>
  </div>
);
